export enum UserRole {
	Admin = '1',
	Dealer = '2',
	Shopkeeper = '3',
}
